import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { afterItems, beforeItems } from "../data/content";
export function BeforeAfter() {
  return <section className="bg-brand-50 px-5 py-16 md:px-8 md:py-24" data-id="element-39" data-mp="3ogauvp93qz4s">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="3oi4153fszhc9">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-41" data-mp="3sgl89mz84rto">
          Before vs. after
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-muted" data-id="element-42" data-mp="3envdat1pwckf">
          What changes when every perimenopause consultation follows the same structured workflow.
        </p>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-43" data-mp="34tlh109nmu4f">
          <div className="rounded-3xl border-2 border-red-200 bg-white p-6 md:p-8" data-id="element-44" data-mp="39q3i9q5s0ac0">
            <div className="flex items-center gap-3" data-id="element-45" data-mp="2vqkf7brtnp6k">
              <span className="rounded-lg bg-red-100 px-3 py-1 text-sm font-extrabold uppercase text-red-700" data-id="element-46" data-mp="2vt6ww48ffl2i">Before</span>
              <h3 className="text-lg font-bold text-ink" data-id="element-47" data-mp="x4k1etoijm3n">Scattered clinical information</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-48" data-mp="t38krdnmab7l">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-base leading-snug text-muted" data-id="element-49" data-mp="172q1r6uo8k6e">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-50" data-mp="123n6ge4htsbm">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-51" data-mp="ef40w6ctvtn8" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-emerald-500 bg-white p-6 shadow-xl shadow-emerald-900/5 md:p-8" data-id="element-52" data-mp="o4xbb418i2pw">
            <div className="flex items-center gap-3" data-id="element-53" data-mp="jbkq73vrke1w">
              <span className="rounded-lg bg-emerald-600 px-3 py-1 text-sm font-extrabold uppercase text-white" data-id="element-54" data-mp="3rsfhdm378a05">After</span>
              <h3 className="text-lg font-bold text-ink" data-id="element-55" data-mp="3msujzg3og9pj">A structured clinical workflow</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-56" data-mp="1qpy6lvoff4sa">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-base font-semibold leading-snug text-ink" data-id="element-57" data-mp="1vosn2qyx8h98">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-white" data-id="element-58" data-mp="20h2k0qygehl0">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-59" data-mp="24jyufudub7dv" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-lg leading-relaxed text-ink" data-id="element-60" data-mp="1gstezgbtah43">
          <strong className="text-brand-800" data-id="element-61" data-mp="1lrms37n6s63q">The result?</strong> A more organized consultation process and a
          documented clinical decision pathway — not a predetermined diagnosis or treatment.
        </p>

        <SectionCTA label="Get my perimenopause decision roadmap" data-id="element-62" data-mp="2x6a5jyz2oqox" />
      </div>
    </section>;
}